import { configureStore } from "@reduxjs/toolkit";
import FavouriteItemSlice from "./slices/FavouriteItemSlice";
import ProfileSlice from "./slices/ProfileSlice";
import CurrentFoodSlice from "./slices/CurrentItemSlice";
import AllItemSlice from "./slices/AllItemSlice";
import AllPostSlice from "./slices/AllPostSlice";
import FAQSlice from "./slices/FaqSlice";
import TestimonialSlice from "./slices/TestimonialSlice";

export const Store = configureStore({
  reducer: {
    FavouriteFood: FavouriteItemSlice,
    Profile: ProfileSlice,
    CurrentFood: CurrentFoodSlice,
    AllItem: AllItemSlice,
    AllPost: AllPostSlice,
    Faq: FAQSlice,
    Testimonial: TestimonialSlice,
  },
});

// Define the RootState type
export type AppDispatch = typeof Store.dispatch;
export type RootState = ReturnType<typeof Store.getState>;
